export default __webpack_public_path__ + "static/media/star.386feae6.svg";